export { WebVitalMetricCard } from './WebVitalMetricCard';
export type { WebVitalMetric, WebVitalMetricCardProps } from './WebVitalMetricCard';

